import { Form } from 'react-bootstrap'
import { ConfigProvider, Select } from 'antd'

export default function SelectStatusBox(props) {

    const { label_name, placeholder, disabled, option, name, defaultValue, onChange, onBlur, error, loading, reference, onInputChange, form_group, onClear, mandatory, customOption, value, tabIndex } = props

    const status_option = [
        { "value": "Active", "label": "Active" },
        { "value": "Inactive", "label": "Inactive" }
    ]

    return (
        <>
            <Form.Group className={form_group ? form_group : "mb-2"} controlId={name}>
                {label_name === '' ? '' : <Form.Label className='form_label'>{label_name}{mandatory ? <span style={{ color: 'red' }}>*</span> : ''}</Form.Label>}

                <ConfigProvider
                    theme={{
                        components: {
                            Select: {
                                borderColor: 'hsl(0, 0%, 80%)',
                                activeBorderColor: '#436a53',
                                activeOutlineColor: 'none',
                                hoverBorderColor: 'none',
                                optionSelectedColor: '#14335d',
                                // optionActiveBg: '#FEF4EA',
                                selectorBg: 'transparent',
                                zIndexPopup: '99999'
                            },
                        },
                        token: {
                            colorBorder: '#ccc',
                            fontFamily: 'Lexend Deca'
                        },
                    }}
                >
                    <Select
                        ref={reference}
                        showSearch
                        // allowClear
                        size='middle'
                        mode="single"
                        placeholder={placeholder}
                        disabled={disabled}
                        loading={loading}
                        options={status_option}
                        name={name}
                        value={value}
                        onChange={onChange}
                        onSearch={onInputChange}
                        // onFocus={onChange}
                        onBlur={onBlur}
                        // onClear={onClear}
                        tabIndex={tabIndex}

                        style={{
                            width: '100%',
                        }}
                    />
                </ConfigProvider>
                {error}
            </Form.Group>
        </>
    )
}
